<template>
  <div>
    <b-overlay
      :show="isLoading"
      rounded="sm"
    >
      <b-card
        no-body
        class="shadow-sm pt-0 pl-0 pr-0 m-4 mb-0"
      >
        <!-- <h6 class="mb-0 text-left">Manage Emloyees</h6> -->
        <b-navbar
          class="background-white"
          toggleable="lg"
        >
          <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
          <b-navbar-brand href="#">
            <strong style="color:#3b3e66">Manage Employee</strong>
          </b-navbar-brand>

          <b-collapse
            id="nav-collapse"
            is-nav
          >
            <b-navbar-nav class="ml-auto">
              <b-nav-form>
                <b-button
                  to="/add-employee-form"
                  class="my-2 my-sm-0 mr-2"
                  variant="outline-primary"
                  size="sm"
                >
                  Add Employee
                </b-button>
                <b-button
                  variant="outline-info"
                  size="sm"
                  class="mr-2"
                  @click="reloadTable"
                >
                  Reload
                </b-button>
                <b-form-group label-for="filterInput">
                  <b-input-group size="sm">
                    <b-form-input
                      v-model="filter"
                      type="search"
                      id="filterInput"
                      placeholder="Type to Search"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button
                        :disabled="!filter"
                        @click="filter = ''"
                      >Clear</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-nav-form>
            </b-navbar-nav>
          </b-collapse>
        </b-navbar>
        <b-table
          class="main-table"
          hover
          striped
          sticky-header="calc(100vh - 295px)"
          ref="table"
          id="employee-table"
          :busy.sync="isLoading"
          :fields="staticFields"
          :items="getEmployeeTableData"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          responsive="sm"
          :per-page="perPage"
          :current-page="currentPage"
          :filter="filter"
          no-sort-reset
        >
          <template v-slot:cell(contact_name)="data">
            <p
              class="link-text"
              @click="OpenDetailPage('/employee-profile/'+data.item.id)"
            >{{ data.item.first_name+' '+data.item.last_name }}</p>
          </template>

          <template v-slot:cell(status)="data">
            <b-badge
              v-if="data.item.status == '1'"
              variant="success"
            >Active</b-badge>
            <b-badge
              v-if="data.item.status == '2'"
              variant="warning"
            >Passive</b-badge>
            <b-badge
              v-if="data.item.status == '3'"
              variant="danger"
            >Terminated</b-badge>
          </template>
          <template v-slot:cell(is_senior_management)="data">
            <b-badge
              v-if="data.item.is_senior_management == '1'"
              variant="success"
            >Yes</b-badge>
            <b-badge
              v-if="data.item.is_senior_management == '0'"
              variant="dark"
            >No</b-badge>
          </template>
          <template v-slot:cell(is_c_suite_officer)="data">
            <b-badge
              v-if="data.item.is_c_suite_officer == '1'"
              variant="success"
            >Yes</b-badge>
            <b-badge
              v-if="data.item.is_c_suite_officer == '0'"
              variant="dark"
            >No</b-badge>
          </template>
          <template v-slot:cell(actions)="data">
            <b-btn
              size="sm"
              variant="outline-success"
              @click="renewForms(data)"
            >Renew</b-btn>
          </template>
        </b-table>
        <template v-slot:footer>
          <b-row>
            <b-col cols="2">
              <b-form-select
                v-model="perPage"
                id="perPageSelect"
                size="sm"
                :options="pageOptions"
              ></b-form-select>
            </b-col>
            <b-col cols="6">
              <p class="text-center">
                Showing Result From
                <b>{{fromRows}}</b> to
                <b>{{toRows}}</b>
              </p>
            </b-col>
            <b-col cols="4">
              <b-pagination
                class="float-right"
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                first-text="First"
                prev-text="Prev"
                next-text="Next"
                last-text="Last"
                aria-controls="employee-table"
              ></b-pagination>
            </b-col>
          </b-row>
        </template>
      </b-card>
    </b-overlay>
    <b-overlay
      :show="showRenewForm"
      no-wrap
    >
      <template v-slot:overlay>
        <div
          v-if="processing"
          class="text-center p-4 bg-primary text-light rounded"
        >
          <font-awesome-icon
            size="lg"
            icon="cloud-upload-alt"
          />
          <div class="mb-3">Renewing...</div>
          <b-progress
            min="1"
            max="20"
            :value="counter"
            variant="success"
            height="3px"
            class="mx-n4 rounded-0"
          ></b-progress>
        </div>
        <div
          v-else
          ref="dialog"
          tabindex="-1"
          role="dialog"
          aria-modal="false"
          aria-labelledby="form-confirm-label"
          class="text-center p-3"
        >
          <p>
            <strong id="form-confirm-label">Are you sure you want to renew {{firstName + ' ' + lastName}}?</strong>
          </p>
          <div>
            <b-button
              variant="outline-success"
              class="mr-3"
              @click="resetRenewForms"
            >Cancel</b-button>
            <b-button
              variant="outline-danger"
              @click="renewFormCall"
            >Yes</b-button>
          </div>
        </div>
      </template>
    </b-overlay>
  </div>
</template>
<script>
import moment from "moment";
import "moment/locale/es";
import { HTTP } from "../../../utils/HTTP";
import { Helper } from "../../../helpers";
export default {
  name: "ActiveEmployeeTable",
  data () {
    return {
      isLoading: false,
      totalRows: 0,
      filter: "",
      perPage: 10,
      currentPage: 1,
      fromRows: 0,
      toRows: 0,
      sortBy: "id",
      sortDesc: true,
      pageOptions: [5, 10, 25, 50, 75, 100],
      staticFields: [
        { key: "contact_name", label: "Contact Name", sortable: false },
        { key: "department", label: "Division/Business Unit", sortable: true },
        { key: "country_name", label: "Country", sortable: true },
        { key: "status", label: "Status", sortable: true },
        { key: "actions", label: "Action", sortable: true },
      ],
      showRenewForm: false,
      processing: false,
      counter: 1,
      interval: null,
      employeeId: null,
      firstName: null,
      lastName: null,
      addEmployeePath: {
        path: '/add-employee-form',
      }
    };
  },
  computed: {
    rows () {
      return this.totalRows;
    },
  },
  beforeDestroy () {
    this.clearInterval();
  },
  methods: {
    clearInterval () {
      if ( this.interval ) {
        clearInterval( this.interval );
        this.interval = null;
      }
    },
    renewForms ( data ) {
      this.employeeId = data.item.id;
      this.firstName = data.item.first_name;
      this.lastName = data.item.last_name;
      this.showRenewForm = true;
    },
    renewFormCall () {
      this.counter = 1;
      this.processing = true;
      this.renewFormApiCall();
      this.clearInterval();
      this.interval = setInterval( () => {
        if ( this.counter < 20 ) {
          this.counter = this.counter + 1;
        } else {
          this.clearInterval();
          this.$nextTick( () => {
            this.resetRenewForms();
          } );
        }
      }, 100 );
    },
    async renewFormApiCall () {
      let formData = {
        employee_id: this.employeeId,
        user_id: localStorage.getItem( "userId" ),
      };
      this.isLoading = true;
      let result = await HTTP(
        "post",
        "api/v1/governance/training/renew",
        formData
      );
      try {
        this.isLoading = false;
        if ( result.data && result.data.status == 1 ) {
          Helper.makeToast( this.$bvToast, "success", result.data.message );
        }
      } catch ( err ) {
        this.isLoading = false;
        return [err];
      }
    },
    resetRenewForms () {
      this.showRenewForm = this.processing = false;
      this.statusKey = 0;
      this.employeeId = null;
      this.firstName = null;
      this.lastName = null;
    },
    createdAtDate ( value ) {
      moment.locale( "en" );
      return moment( value ).format( "DD/MM/YYYY" );
    },
    reloadTable () {
      this.$root.$emit( "bv::refresh::table", "employee-table" );
    },
    async getEmployeeTableData () {
      let formData = {
        filter: this.filter,
        sort: this.sortBy + "|" + ( this.sortDesc == true ? "desc" : "asc" ),
        per_page: this.perPage,
        page: this.currentPage,
      };
      this.isLoading = true;
      let response = await HTTP( "post", "api/v1/employees/data", formData );
      try {
        this.totalRows = response.data.total;
        this.fromRows = response.data.from;
        this.toRows = response.data.to;
        this.$store.state.activeEmployeeTabLazyLoad = false;
        this.isLoading = false;
        return response.data.data;
      } catch ( err ) {
        this.isLoading = false;
        return [err];
      } finally {
        this.isLoading = false;
      }
    },
    OpenDetailPage ( url ) {
      this.$router.push( url );
    },
    OpenAddEmployeePage () {
      this.$router.push( this.addEmployeePath.path );
    },
  },
};
</script>